import {createAction, props} from "@ngrx/store";
import {HttpErrorResponse} from "@angular/common/http";
import {TenFinanceDebtors, TenFinanceSettings} from "../../_models/finances.models";
import {DahPaginationModel, NameResponse} from '@common/models/commonHTTP.models';

export const SetBuildingId = createAction(
    '[Finances] Set Building Id',
    props<{ buildingId: string }>()
);

export const SetAvailableBuildings = createAction(
    '[Finances] Set Available Buildings',
    props<{ availableBuildings: NameResponse[] }>()
);

export const SetTab = createAction(
    '[Finances] Set Tab',
    props<{ tab: 1 | 2 }>()
);

// <editor-fold desc="Finance Settings">
export const SetDateRange = createAction(
    '[Finances] Set Date Range',
    props<{ from: string, to: string }>()
);

export const LoadSettings = createAction(
    '[Finances] Load Settings'
);

export const LoadSettingsSuccess = createAction(
    '[Finances] Load Settings Success',
    props<{ settings: TenFinanceSettings }>()
);

export const LoadSettingsFailure = createAction(
    '[Finances] Load Settings Failure',
    props<{ error: HttpErrorResponse }>()
);
// </editor-fold>

// <editor-fold desc="Finance Debtors">
export const LoadDebtors = createAction(
    '[Finances] Load Debtors',
    props<{ nextPage?: boolean, clearState?: boolean }>()
);

export const LoadDebtorsSuccess = createAction(
    '[Finances] Load Debtors Success',
    props<{ items: TenFinanceDebtors[], totalByPages: number, pagination: DahPaginationModel }>()
);

export const LoadDebtorsFailure = createAction(
    '[Finances] Load Debtors Failure',
    props<{ error: HttpErrorResponse }>()
);

export const SetDebtorsSort = createAction(
    '[Finances] Set Debtors Sort',
    props<{ sort: 'APARTMENT' | 'DEBT_DESC' }>()
);
// </editor-fold>
